(function($){
  $(document).ready(function() {

    $('#print-page').click(function(e){
        e.preventDefault();
        window.print();
    });

    $("body").on("click", "a", function(e){
        const regexp = new RegExp("^https?:\/\/(?!" + window.location.hostname + ")\/?", "g");
        const href = $(this).attr("href");
        if (href != undefined && $(this).attr("target") != '_blank'){
            if (href.match(regexp) != null || href.indexOf('.pdf') != -1){
                e.preventDefault();
                window.open(href);
            }
        }
    });

  });
})(jQuery);
